import { useCallback, useEffect, useState } from "react";
import { Dashboard } from "@/components/dashboard/Dashboard";
import { CreatePortfolio } from "@/components/create/CreatePortfolio";
import "./index.css";

/** Minimal client router: tracks the path and navigates via the History API. */
function usePathname() {
  const [pathname, setPathname] = useState(() => window.location.pathname);

  useEffect(() => {
    const onPop = () => setPathname(window.location.pathname);
    window.addEventListener("popstate", onPop);
    return () => window.removeEventListener("popstate", onPop);
  }, []);

  const navigate = useCallback((to: string) => {
    window.history.pushState({}, "", to);
    setPathname(to);
  }, []);

  return { pathname, navigate };
}

export function App() {
  const { pathname, navigate } = usePathname();

  // First path segment is the portfolio slug; empty → create page.
  const slug = pathname.replace(/^\/+/, "").split("/")[0];

  if (!slug) {
    return <CreatePortfolio onCreated={(s) => navigate(`/${s}`)} />;
  }
  return <Dashboard slug={slug} onNavigateHome={() => navigate("/")} />;
}

export default App;
